module.exports = __webpack_public_path__ + "static/media/john-jennings.0ee69b18.jpg";